module.exports = __webpack_public_path__ + "d568f5597087d6e5238def0b13441806.MP3";